import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from '../lib/firestore.service';
import type { TServiceArea } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class ServiceAreasService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getObservable(): Observable<TServiceArea[]> {
        const path = this.firestorePathsService.getServiceAreasPath();
        const observable = this.firestoreService.getObservable(path) as Observable<TServiceArea[]>;
        return observable;
    }

    // Return the promise of the object beneath the key value.
    public async getByUid(uid: string): Promise<TServiceArea> {
        const path = this.firestorePathsService.getServiceAreasPath();
        return this.firestoreService.getByUid(path, uid) as Promise<TServiceArea>;
    }

    public async getByFieldValue(fieldName: string, fieldValue: string): Promise<TServiceArea[]> {
        const path = this.firestorePathsService.getServiceAreasPath();
        return this.firestoreService.getByFieldValue(path, fieldName, fieldValue) as Promise<TServiceArea[]>;
    }

    public async getAll(): Promise<TServiceArea[]> {
        const path = this.firestorePathsService.getServiceAreasPath();
        return this.firestoreService.getAll(path) as Promise<TServiceArea[]>;
    }

    public async set(area: TServiceArea): Promise<TServiceArea> {
        area.uid = area.zipcode;
        const path = this.firestorePathsService.getServiceAreasPath();
        return this.firestoreService.set(path, area) as Promise<TServiceArea>;
    }

    public async update(area: TServiceArea): Promise<TServiceArea> {
        const path = this.firestorePathsService.getServiceAreasPath();
        return this.firestoreService.update(path, area) as Promise<TServiceArea>;
    }

    public async delete(uid: string): Promise<void> {
        const path = this.firestorePathsService.getServiceAreasPath();
        return this.firestoreService.delete(path, uid);
    }
}
